import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=f8644450"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports